import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../../jsx/layouts/PageTitle";
import ReactPaginate from "react-paginate";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { formatDateTime } from "../../../utils/dateTimeFormate";
import {
    deleteVerifiedUserData, disableVerifiedUserData,
    getAlldataverifiedDwnload,
    getVerifieddataInsitutionList,
    getVerifieddataList
} from "../../../services/adminApiService/verifiedlistApiService/VerifiedLIstApiService";
import FilterNumber from "../../../jsx/components/FilterNumberDropDown/FilterNumber";
import SearchFilter from "../../../jsx/components/SearchFilter/SearchFilter";
import useSearchValue from "../../../hooks/useSearchValue";
import DistrictFilter from "../districtFilter/DistrictFilter";
import { LocationContext } from "../../../context/LocationContext";
import CategorySubCategoryFilter from "../categorySubCateogoryFilter/CategorySubCategoryFilter";
import { useCategoryFilter } from "../../../context/CategoryFilterContext";
import RefreshButton from "../../../jsx/components/RefreshButton/RefreshButton";
import { useFilterReset } from "../../../hooks/useFilterReset";
import SportFilter from "../sportFilter/SportFilter";
import { useSport } from "../../../context/SportContext";
import DownloadExcelButton from "../../../jsx/components/DownloadExcelButton.jsx/DownloadExcelButton";
import { organisationExcelHeaders } from "../organization/InsitutionExcelHeader";
import { VerifiedorganisationExcelHeaders } from "./VerifiedInsituteExcelData";
import { getOrganisationListForExcel } from "../../../services/adminApiService/organisationApi/OrganisationApiService";
import {
  exportToExcel,
  exportVerifiedToExcel,
} from "../../../utils/exportToExcel";

import swal from "sweetalert";
import notify from "../../../utils/notification";
import FormCheck from "react-bootstrap/FormCheck";

const InsituteVeriedUserList = ({ roletype, roleCategory }) => {
  const { selectedDistrictId, setSelectedDistrictId } = useContext(LocationContext);
  const { selectedSubCategoryId, setSelectedSubCategoryId } = useCategoryFilter();
  const [verifiedUserdataList, setVerifiedUserdataList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const { searchValue, setSearchValue, debouncedSearchValue, setDebouncedSearchValue } = useSearchValue();
  const [selectedCategory, setSelectedCategory] = useState('');
  const [selectedSubCategory, setSelectedSubCategory] = useState('');
    const [isChecked, setIsChecked] = useState(false);
    const [toggleState, setToggleState] = useState({});
  const handleVerificationInsituteClick = (id) => {
    navigate(`/verification-insitute-view-form/${id}`); // Absolute path
  };
  const { selectedSportId, setSelectedSportId } = useSport();
  const getverifiedListApi = async (roletype, perPage, currentPage, searchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId) => {
    setLoading(true);
    try {
      const response = await getVerifieddataInsitutionList(
        roletype,
        perPage,
        currentPage,
        searchValue,
        selectedDistrictId,
          selectedCategory,
        selectedSubCategoryId,
        selectedSportId
      );

      setVerifiedUserdataList(response?.data?.data);
    } catch (error) {
      console.error("Login error:", error);
    } finally {
      setLoading(false);
    }
  };

    const handleDataToExcel = async () => {
    try {
      const response = await getOrganisationListForExcel(
        searchValue,
        selectedDistrictId,
        selectedSubCategoryId,
        selectedSportId,
      );
      const data = response.data;
      exportVerifiedToExcel(data, "InsitutionListVerified.csv");
    } catch (error) {
      console.error("Login error:", error);
    }
  };

    const handleStatusToggle = async (id) => {
        const currentChecked = toggleState[id] ?? false;
        const newChecked = !currentChecked;
        console.log("newChecked====>",newChecked);

        // true → 0 (active), false → 1 (inactive)
        const newStatus = newChecked ? 0 : 1;
        // 🔴 Show confirmation ONLY when disabling


        const isConfirm = await swal({
            title:
                newStatus === 1
                    ? "Are you sure you want to disable this institution?"
                    : "Are you sure you want to enable this institution?",
            text:
                newStatus === 1
                    ? "Disabling this institution will restrict access to its services and may impact any active users or data associated with it."
                    : "Once enabled, the institution will be able to access the system.",
            icon: "warning",
            buttons: ["Cancel", newStatus === 1 ? "Yes, Disable" : "Yes, Enable"],
            dangerMode: newStatus === 1, // red warning only for disable
        });
        if (!isConfirm) return; // ❌ Cancel clicked
        // ✅ Optimistic UI update
        setToggleState(prev => ({
            ...prev,
            [id]: newChecked,
        }));

        const payload = {
            id,
            status: newStatus,
        };

        try {
            await disableVerifiedUserData(payload);
            getverifiedListApi(roletype, perPage, currentPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId);
        } catch (error) {
            console.error("API failed", error);

            // ❌ Rollback on API failure
            setToggleState(prev => ({
                ...prev,
                [id]: currentChecked,
            }));
        }
    };


    useEffect(() => {
    getverifiedListApi(roletype, perPage, currentPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId);
  }, [currentPage, perPage, debouncedSearchValue, selectedDistrictId,selectedCategory, selectedSubCategoryId, selectedSportId]);

  const handlePageChange = (event) => {
    // Adjusting for zero-based index by adding 1
    const selectedPage = event.selected + 1;
    setCurrentPage(selectedPage);
  };
  const handleRefresh = useFilterReset({
    setSearchValue,
    setDebouncedSearchValue,
    setSelectedDistrictId,
      selectedCategory,
    setSelectedSubCategoryId,
    setCurrentPage,
    setSelectedCategory,
    setSelectedSubCategory,
    setPerPage,
    setSelectedSportId,
    fetchFunction: getverifiedListApi,


  });

    useEffect(() => {
        if (verifiedUserdataList?.data?.length) {
            const state = {};

            verifiedUserdataList?.data?.forEach(item => {
                state[item.id] = item.is_deleted === 0; // ✅ 0 = active, 1 = inactive
            });

            setToggleState(state);
        }
    }, [verifiedUserdataList]);

  useEffect(() => {
    setCurrentPage(1);
    setPerPage(10);
    // setSelectedStatus(0);
    setDebouncedSearchValue("");
    setSelectedDistrictId("");
    setSelectedSubCategoryId("");
    setSelectedSportId("");
  }, []);
  return (
    <>
      <PageTitle
        activeMenu="Institution Verification List"
        motherMenu="Manage Verification"
      />
      <div className="col-12">
        <div className="card">
          <div className="d-flex justify-content-between px-3">
            <div className="d-flex mt-3">
              <div>
                <FilterNumber value={perPage} onChange={setPerPage} />
              </div>
              <div>
                <SearchFilter searchValue={searchValue} setSearchValue={setSearchValue} />
              </div>

            </div>
            <div className="d-flex mt-3">




              <div className="mx-2">
                {/* <DownloadExcelButton
                  //  data={verifiedUserdataList}
                  data={
                    (verifiedUserdataList?.data || verifiedUserdataList || []).map((item, index) => ({
                      serial: index + 1, // ✅ add serial number
                      ...item,
                    }))
                  }
                  // headers={VerifiedorganisationExcelHeaders}
                  headers={[
                    { label: "Sr.No", key: "serial" }, // ✅ add serial header
                    ...VerifiedorganisationExcelHeaders,
                  ]}
                  fileName="InsitutionListVerified.xlsx"
                  btnName="Download Excel" /> */}
                  <DownloadExcelButton
                  userId={2}
                  searchValue={searchValue}
                  selectedDistrictId={selectedDistrictId}
                  selectedSubCategoryId={selectedSubCategoryId}
                  selectedSportId={selectedSportId}
                  fileName="InsitutionListVerified.xlsx"
                  btnName="Download Excel"
                />
              </div>
              <div className="">
                <DownloadExcelButton
                  // headers={VerifiedorganisationExcelHeaders}
                  headers={[
                    { label: "S.No", key: "serial" }, // Add Serial Number column
                    ...VerifiedorganisationExcelHeaders
                  ]}
                  btnName="Download All Data"
                  fileName="AllIndividualListVerified.xlsx"
                  // onClick={async () => {
                  //   const response = await getAlldataverifiedDwnload(2);
                  //   const allData = response?.data?.data || [];
                  //   return allData; // will be exported automatically inside the button
                  // }}
                  onClick={async () => {
                    const response = await getAlldataverifiedDwnload(2);
                    const allData = response?.data?.data || [];
                    const withSerial = allData.map((item, index) => ({
                      serial: index + 1,  // matches header key
                      ...item
                    }));

                    return withSerial;
                  }}
                />
              </div>

              <div>
                <RefreshButton refreshCallback={handleRefresh} />
              </div>
            </div>

          </div>

          <div className="d-flex px-3">
            <div className="d-flex mt-3">

              <div>
                <DistrictFilter />

              </div>
            </div>
            <div className="d-flex mt-3">

              <div className="mx-3">
                <CategorySubCategoryFilter typeId="2"
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedSubCategory={selectedSubCategory}
                  setSelectedSubCategory={setSelectedSubCategory}
                  placeholderText="Institution"
                />
              </div>
              {/* <div className="mx-3">
                <CategorySubCategoryFilter typeId="1"
                  selectedCategory={selectedCategory}
                  setSelectedCategory={setSelectedCategory}
                  selectedSubCategory={selectedSubCategory}
                  setSelectedSubCategory={setSelectedSubCategory}
                  placeholderText="Institution"
                />
              </div> */}

              <div>
                <SportFilter />
              </div>

            </div>

          </div>
          <div className="card-body">
            {loading ? (
              <div className="text-center">
                <div className="spinner-border text-primary" role="status">
                  <span className="sr-only">Loading...</span>
                </div>
              </div>
            ) : (
              <div className="w-100 table-responsive">
                <div id="example_wrapper" className="dataTables_wrapper">
                  <table id="example" className="display w-100 dataTable">
                    <thead>
                      <tr>
                        <th>SN</th>
                        {/* <th>Legal Entity</th> */}
                        <th>Reg. No</th>
                        <th>Atom Id</th>
                        <th>Name of Institution</th>
                        {/* <th>Contact Person Email</th> */}
                        <th>Contact Person Mobile</th>
                        <th>Registration Date</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {verifiedUserdataList?.data?.length > 0 ? (
                        verifiedUserdataList.data.map((data, index) => {

                          return (
                            <tr key={index}>
                              <td>{index + 1 + (currentPage - 1) * perPage}</td>
                              {/* <td>{data?.name_of_legel_entity}</td> */}
                              <td>{data?.organization?.registration_number}</td>
                              <td>{data?.atom_id}</td>
                              <td>
                                {data?.organization?.name_of_organization}
                              </td>
                              {/* <td>
                                {data?.organization?.contact_person_email}
                              </td> */}
                              <td>
                                {data?.organization?.contact_person_contact}
                              </td>
                              <td>{formatDateTime(data?.created_at)}</td>

                              <td>
                                <span className="text-success">Verified</span>
                              </td>
                              <td>
                                <div className="d-flex">
                                    <div className="mx-2">
                                        {/*<FormCheck*/}
                                        {/*    type="switch"*/}
                                        {/*    id={`status-switch-${data?.id}`}*/}
                                        {/*    checked={isChecked}*/}
                                        {/*    onChange={() => setIsChecked(!isChecked)}*/}
                                        {/*/>*/}





                                    </div>
                                    <div className="mx-3">
                                        <FormCheck
                                            type="switch"
                                            id={`status-switch-${data?.id}`}
                                            checked={toggleState[data.id] ?? false}
                                            onChange={() => handleStatusToggle(data.id)}
                                        />
                                    </div>
                                  <Button
                                    style={{ whiteSpace: "nowrap" }}
                                    onClick={() =>
                                      handleVerificationInsituteClick(data?.id)
                                    }
                                  >
                                    {" "}
                                    View More{" "}
                                  </Button>
                                </div>
                              </td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="9" className="text-center">
                            Data is not available
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
        <ReactPaginate
          nextLabel="next >"
          onPageChange={handlePageChange}
          pageRangeDisplayed={8}
          marginPagesDisplayed={7}
          pageCount={Math.ceil(verifiedUserdataList?.total / perPage)}
          previousLabel="< previous"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakLabel="..."
          breakClassName="page-item"
          breakLinkClassName="page-link"
          containerClassName="pagination d-flex flex-wrap"
          activeClassName="active"
          renderOnZeroPageCount={null}
        />
      </div>
    </>
  );
};

export default InsituteVeriedUserList;
